module.exports = __webpack_public_path__ + "assets/img/step1.10829582.jpg";